import {
  ASSESSMENT_TYPE } from 'frontcore/constants/taskManager'

export function getAssessmentType (is_na, assessment_type) {

  switch (assessment_type) {
  case ASSESSMENT_TYPE.OK_NOK:
    return is_na ? ASSESSMENT_TYPE.OK_NOK_NA : ASSESSMENT_TYPE.OK_NOK
  case ASSESSMENT_TYPE.VALUE:
    return is_na ? ASSESSMENT_TYPE.VALUE_NA : ASSESSMENT_TYPE.VALUE
  case ASSESSMENT_TYPE.NUMERIC_SCALE:
    return ASSESSMENT_TYPE.NUMERIC_SCALE
  case ASSESSMENT_TYPE.PERCENTAGE:
    return ASSESSMENT_TYPE.PERCENTAGE
  default:
    return null
  }
}

export function getAssessmentTypeNaMap (assessment_type) {

  switch (assessment_type) {
  case ASSESSMENT_TYPE.OK_NOK_NA:
    return ASSESSMENT_TYPE.OK_NOK
  case ASSESSMENT_TYPE.VALUE_NA:
    return ASSESSMENT_TYPE.VALUE
  default:
    return assessment_type
  }
}

